import { Camera } from "lucide-react";
import { toast } from "sonner";
import { EVENT_CONFIG } from "@/config/eventConfig";
import { SectionHeading, Reveal, GoldButton } from "./shared";

const AdultProm = () => {
  const { images, dressCode, hashtags } = EVENT_CONFIG;

  const gallery = [
    { src: images.gownLineup, alt: "Guests in spectacular gowns at the gala" },
    { src: images.tuxedo, alt: "Black-tie suiting inspiration" },
    { src: images.gownGroup, alt: "Friends dressed for adult prom" },
    { src: images.fashion, alt: "High-fashion eveningwear" },
    { src: images.gown, alt: "Couture gown detail" },
    { src: images.stepRepeat, alt: "Step and repeat photo moment" },
  ];

  const shareLook = async () => {
    const text = `What are you wearing to Adult Prom? ${hashtags.join(" ")}`;
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Hashtags copied — post your look and tag Styles 4 Kidz!");
    } catch {
      toast.info(hashtags.join(" "));
    }
  };

  return (
    <section id="adult-prom" data-testid="adult-prom-section" className="relative py-24 sm:py-32 bg-wine/15 grain overflow-hidden">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-champagne/50 to-transparent" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center gap-14">
        <SectionHeading
          chapter="04"
          eyebrow="Dress Like You Mean It"
          title={
            <>
              YES. IT'S AN <span className="gold-shimmer">ADULT PROM.</span>
            </>
          }
          sub="Remember getting dressed up for the biggest night of your life? Now imagine doing it again — except this time, you're helping build a future for children."
        />

        <Reveal className="w-full">
          <p className="text-xs uppercase tracking-[0.35em] text-gold mb-5 text-center">What will you wear?</p>
          <div
            data-testid="adult-prom-gallery"
            className="flex gap-4 sm:gap-5 overflow-x-auto no-scrollbar snap-x snap-mandatory pb-2 -mx-4 px-4 sm:mx-0 sm:px-0"
          >
            {gallery.map((g, gi) => (
              <div
                key={g.src}
                className={`group shrink-0 w-64 sm:w-80 snap-center overflow-hidden gold-stroke spotlight-card ${
                  gi % 2 === 0 ? "rounded-t-[9rem] rounded-b-2xl" : "rounded-2xl"
                }`}
              >
                <img
                  src={g.src}
                  alt={g.alt}
                  loading="lazy"
                  className="w-full h-80 sm:h-96 object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-110"
                />
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal className="flex flex-wrap justify-center gap-2.5 max-w-3xl">
          {dressCode.map((d) => (
            <span
              key={d}
              className="px-4 py-2 rounded-full bg-ink/60 border border-champagne/20 text-cream text-[11px] uppercase tracking-[0.18em]"
            >
              {d}
            </span>
          ))}
        </Reveal>

        <Reveal className="flex flex-col items-center gap-5">
          <GoldButton testid="adult-prom-share-look-button" variant="outline" onClick={shareLook}>
            <Camera size={15} /> Show Us Your Look
          </GoldButton>
          <div className="flex flex-wrap justify-center gap-x-5 gap-y-1">
            {hashtags.map((h) => (
              <span key={h} className="text-champagne/70 text-xs sm:text-sm tracking-wide">
                {h}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default AdultProm;
